import { render, staticRenderFns } from "./ReportButton.vue?vue&type=template&id=898fdca2"
import script from "./ReportButton.vue?vue&type=script&lang=js"
export * from "./ReportButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports